import { stringValue } from "./audio-media-utils.mjs";
import type { AudioArticleInput } from "./audio-types";

export function dashboardBriefingAudioKey(): string {
  return "dashboard-briefing";
}

export function newsCategoryAudioKey(sourceId: string): string {
  return `news-category:${String(sourceId || "news")
    .trim()
    .toLowerCase()}`;
}

export function newsStoryAudioKey(item: AudioArticleInput): string {
  return `news-story:${stringValue(item.link || item.url) || stringValue(item.title) || "story"}`;
}

export function stockWhyAudioKey(symbol: string): string {
  return `stock-why:${String(symbol || "stock")
    .trim()
    .toUpperCase()}`;
}

export type ContentAudioKind = "spark" | "fact" | "idea" | "quote" | "lesson";

export function contentAudioKey(kind: ContentAudioKind, id: string): string {
  return `${kind}-listen:${stringValue(id) || kind}`;
}
